import { atom } from "jotai";

export declare type selectedItem = {
    coursePart?: string;
    course?: string;
}
export const selectedAtom = atom<selectedItem>({});
selectedAtom.debugLabel = "selectedAtom";